import React from 'react'

const PrevArrow = ({ className, onClick }) => (
    <button className={`${className} !left-0 z-10`} onClick={onClick} type="button">
        <img
            src="../../assets/images/icons/arrow-chevron-left.svg"
            alt="prev"
            className="w-6 h-6"
        />
    </button>
);

export default PrevArrow
